<template>
	<div id="app" v-touch:tap='onClick'>
		<div class="header hide-portrait">
			<div class="header-content">
				<div class="logo-container">
					<WFBuildingLogo />
				</div>
				<div v-if="this.languagesVisible()" class="language-container hide-portrait">
					<WFFlagsMenu  :showFlag="false" :showTitle="false" labelType='code' />
				</div>
			</div>
		</div>
		<div class="main" @click="offShortcutsClick()">
			<Search @clicked="onSearchPOIClick" @close="onSearchClose" ref="search" :showKeyboard="true" :class='{"search-visible": searchVisible}'/>
			<div class="map-area-container" :class="{'map-search-visible': searchVisible}">
				<WFMap @poiClicked="onMapPOIClick" @onTouch="onClick" @loaded="mapLoaded" ref="map" :api="apiHost" :assets="assetHost" project="d0aad8204c40d1b772fbdf0e39812527"/>
				<WFFloorsMenu :currentFloor="currentFloor" :hideWhenSingleFloor="true"/>
				<div class="loading" v-if="loading"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>
				<div class="map-btns hide-portrait">
					<WFYAH/>
					<div @click.stop="onShortcutsButtonClick()" class="quick-button" role="button">
						<div class="quick-button-content">
							<img src="./assets/FACILITIES.png">
							<p data-translation-element="quick-buttons">FACILTIES</p>
						</div>
						<!-- <p data-translation-element="quick-buttons">FACILTIES</p> -->
					</div>
				</div>
				<div class="shortcuts-wrapper" v-show="shortcutsHidden">
					<div @click.stop="onShortcutsButtonClick()" class="back-button-shortcuts">
						<img src="./assets/back-arrow.png">	
					</div>
					<ShortcutsMenu v-on:changeValue="handleChangeValue()" @clicked="showShortcut"/>
				</div>
				<div class="map-logo-container">
					<WFBuildingLogo />
				</div>
			</div>
			<div class="menus">
				<div class="menus-bottom">
					<div class="search-bar">
						<div @click="onBackClick()" class="home-button hide-landscape">
							<img src="./assets/home-button.svg">
						</div>
						<TabButtons @switchTab="switchMainTab" />
						<WFYAH class="hide-landscape"></WFYAH>
						<div v-if="this.languagesVisible()" class="language-container hide-landscape">
							<WFLanguagesMenu :showFlag="false" :showTitle="false" labelType='code' />
						</div>
						<div @click.stop="onShortcutsButtonClick()" class="quick-button hide-landscape" role="button">
							<div class="quick-button-content">
								<img src="./assets/FACILITIES.png">
								<p data-translation-element="quick-buttons">FACILTIES</p>
							</div>
							<!-- <p data-translation-element="quick-buttons">FACILITIES</p> -->
						</div>
					</div>
					<div class="col col-tabs-container tabs-container">
						<WFTabs ref="tabs" :activeTab="currentTab" animate="horizontal">
							<WFTab name="groups">
								<WFScrollableArea>
									<GroupsMenu @poiClicked="onPOIClick" @clicked="onGroupMenuClick" @onSubGroupClick="onSubGroupMenuClick" :order="true" :showPOIs="false" :show-icon="true" :showSubGroups="false" />
								</WFScrollableArea>
							</WFTab>
							<WFTab name="sub-groups">
								<WFScrollableArea>
									<SubGroupsMenu @poiClicked="onPOIClick" @clicked="onSubGroupMenuClick" @onBackClick="onBackClick" :order="true" :parent="this.currentParent" :parentName="this.parentName" :headerColor="this.subGroupHeaderColor" :showPOIs="false" :show-icon="true"/>
								</WFScrollableArea>
							</WFTab>
							<WFTab name="group-pois">
								<WFScrollableArea>
									<GroupPOIsMenu v-show="currentGroup" :group="currentGroup" :parentName="this.parentName" :headerColor="this.subGroupHeaderColor" @clicked="onPOIClick" @back="onBackClick"/>
								</WFScrollableArea>
							</WFTab>
							<WFTab name="poi-info">
								<div class="scrollable">
									<div class="poi-container">
										<div @click="onPOIBackClick()" class="back-button">
											<img src="./assets/back-arrow.png">	
										</div>
										<POI @showPath="showPath" @showAccessibilityPath="showAccessibilityPath" :poi="currentPOI" :showLogo="true" :showPathButton="true" :showAccessibilityPathButton="true" :showDescription="true"/>
									</div>
								</div>
							</WFTab>
						</WFTabs>
					</div>
				</div>
			</div>
		</div>
		<div id="screensaver" class="banners-screensaver hide-mobile" v-show="screensaver">
			<WFBanner template="default" container="screensaver" class="hide-portrait" @clicked="onBannerClick" @hasbanners="hasBanners" :qrURL="qrURL"></WFBanner>
			<WFBanner template="default" container="screensaver-portrait" class="hide-landscape" @clicked="onBannerClick" @hasbanners="hasBanners" :qrURL="qrURL"></WFBanner>
		</div>
	</div>
</template>

<script>
/* global wayfinder */
import {WFShortcutsMenu, WFLanguagesMenu, WFMap, WFFloorsMenu, WFTabs, WFTab, WFGroupsMenu, WFAZMenu, WFScrollableArea, WFPOI, WFBanner, WFBuildingLogo, WFYAH, WFGroupPOIsMenu} from '@3dwayfinder/wayfinder-vue-components'

import TabButtons from './components/TabButtons.vue'
import Search from './components/Search.vue'
import SearchComponent from './components/SearchComponent.vue'
import FlagsMenu from './components/FlagsMenu.vue'
import ShortcutsMenu from './components/ShortcutsMenu.vue'
import ImageOverlay from './components/ImageOverlay.vue'
import BrowserOverlay from './components/BrowserOverlay.vue'
import GroupsMenu from './components/GroupsMenu.vue'
import SubGroupsMenu from './components/SubGroupsMenu.vue'
import GroupPOIsMenu from './components/GroupPOIsMenu.vue'
import POI from './items/POI.vue'
import Group from './items/Group.vue'


import { onBeforeUnmount, onMounted } from 'vue'

//import {ClockComponent} from 'vue-clock'
import { mapState } from 'vuex';

export default {
	name: 'app',
	components: {
		WFMap,
		WFFloorsMenu,
		WFAZMenu,
		WFGroupsMenu,
		GroupsMenu,
		SubGroupsMenu,
		Group,
		POI,
		FlagsMenu,
		WFBuildingLogo,
		WFYAH,
		WFShortcutsMenu,
		//ClockComponent,
		WFLanguagesMenu,
		TabButtons,
		WFPOI,
		WFTabs,
		WFTab,
		BrowserOverlay,
		Search,
		ShortcutsMenu,
		WFBanner,
		WFScrollableArea,
		WFGroupPOIsMenu,
		GroupPOIsMenu,
		ImageOverlay,
		SearchComponent
	},

	useClickOutside(
		component,
		callback,
		excludeComponent
		) {
		// fail early if any of the required params is missing
		if (!component) {
			throw new Error('A target component has to be provided.')
		}

		if (!callback) {
			throw new Error('A callback has to be provided.')
		}

		const listener = (event) => {
			if (
			event.target === component.value ||
			event.composedPath().includes(component.value) ||
			event.target === excludeComponent.value ||
			event.composedPath().includes(excludeComponent.value)
			) {
			return
			}
			if (typeof callback === 'function') {
			callback()
			}
		}

		onMounted(() => {
			window.addEventListener('click', listener)
		})

		onBeforeUnmount(() => {
			window.removeEventListener('click', listener)
		})
	},
	data () {
		return {
			lastClick: false,
			screensaver: false,
			hasScreensaver: true,
			menuActive: false,
			overlayImage: -1,
			overlayOpen: false,
			browserOpen: false,
			backClick: false,
			currentParent: 0,
			parentName: '',
			subGroupHeaderColor: null,
			// currentGroup: null,
			//searchVisible: false,
			loading: true,
			shortcutsHidden: false,
			qrURL: "https://clients.3dwayfinder.com/Amanda/?kiosk={kiosk}&map2DRotation={rot}",
			busTimes: "https://sanntidsskjerm.kolumbus.no/?c=6FB1FAEDE188CD0339771F597D30C44C&noconfig",
			offShortcuts: false,
		}
	},
	computed: {//yahLogo
		...mapState('wf', ['maxInActivity', 'currentFloor', 'landscape', 'portrait', 'template', 'mobile','poiGroups', 'languages']),
		...mapState(['searchVisible', 'currentGroup', 'currentPOI', 'currentTab']),
		apiHost () {
			return this.$WF_API_HOST;
		},
		assetHost () {
			return this.$WF_ASSET_HOST;
		}
	},
	methods: {
		onClick () {
			clearTimeout(this.lastClick);
			this.$refs['map'].run();
			
			this.lastClick = setTimeout(() => {
				if(this.$refs.map) {
					this.$refs.map.reset();
				}
				this.reset();
			}, this.maxInActivity * 1000);
			//return false;
		},
		languagesVisible() {
			if (this.languages.length > 1) {
				return true;
			} else {
				return false;
			}
		},
		changeTab (tab) {
			this.currentTab = tab;			
		},
		offShortcutsClick() {
			if(this.shortcutsHidden) {
				this.handleChangeValue();
			}
		},
		showPath(poi) {
			this.$store.dispatch('setPOI', poi);
			this.$store.dispatch('showSearch', false);
			// this.searchVisible = false;
			// console.log(this.searchVisible);
			this.$wayfinder.setHighlights([poi])
			this.$wayfinder.showPath(poi.getNode(), poi);
		},
		showAccessibilityPath(poi) {
			this.$store.dispatch('setPOI', poi);
			//this.searchVisible = false;
			this.$store.dispatch('showSearch', false);
			this.$wayfinder.setHighlights([poi])
			this.$wayfinder.showPath(poi.getNode(), poi, {"ignoreTypes": ["escalator", "stairs"]});
		},
		subgroupsExist(group) {
			return group.childGroups.length > 0;
		},
		onBackClick() {
			this.$store.dispatch('setTab', 'groups');
			this.$store.dispatch('setGroup', null);
			this.$wayfinder.clearPath();
			this.$wayfinder.clearHighlights();
			this.$wayfinder.showKiosk();
			this.isHighlighted = false;
			this.backClick = false;
			this.handleChangeValue();
			
		},
		onPOIBackClick() {
			if(this.currentGroup != null) {
				this.$store.dispatch('setTab', 'group-pois');
				this.$wayfinder.clearPath();
				this.$wayfinder.clearHighlights();
				this.$wayfinder.showKiosk();
				this.isHighlighted = false;
			} else {
				this.onBackClick();
			}
		},
		showNearestPOI(group) {
			var nearest = this.$wayfinder.getNearestPOI(this.$wayfinder.getKiosk(), group.pois);
			this.$wayfinder.showPath(nearest.getNode(), nearest, {"ignoreTypes": ["escalator", "stairs"]})
		},
		onGroupMenuClick (group) {
			this.backClick = true;
			if(group == null || group != this.currentGroup) {
				this.$wayfinder.clearHighlights();
				this.$store.dispatch('setGroup', group);
				this.currentParent = this.currentGroup.id;
				this.parentName = this.currentGroup.names.translations.en;
				this.subGroupHeaderColor = this.getGroupColor(this.currentGroup);
				this.$wayfinder.setHighlights(this.getGroupPois(group));
				this.isHighlighted = true;
			} else {
				if(this.isHighlighted) {
					this.$wayfinder.clearHighlights();
					this.isHighlighted = false;
				} else {
					this.isHighlighted = true;
					this.$wayfinder.setHighlights(this.getGroupPois(this.currentGroup));
				}
			}
			if (this.subgroupsExist(group)) {
				this.$store.dispatch('setTab', 'sub-groups');
			} else {
				this.$store.dispatch('setTab', 'group-pois');
			}
		},
		getGroupById(id) {
			//console.log()
			for (let group in this.poiGroups) {
				if (this.poiGroups[group].id == id) {
					//console.log(this.poiGroups[group] + ', grupp') ;
					return this.poiGroups[group];
					break;
				}
			}
		},
		getGroupPois(group) {
			let subGroupIds = group.childGroups;
			//console.log(subGroupIds)
			let groupPois = [];
			for (let id in subGroupIds) {;
				//console.log(id);
				let subGroup = this.getGroupById(subGroupIds[id]);
				// console.log("subgupp:")
				// console.log(subGroup);
				for (let poi in subGroup.pois) {
					groupPois.push(subGroup.pois[poi]);
				}
			}
			//console.log("grupi poid:" + groupPois);
			return groupPois;
		},
		getGroupColor(group) {
            return group.getColor();
        },
		onSubGroupMenuClick(group) {
			this.backClick = true;
			if(group.id < 183 || group.id > 191) {
				this.$store.dispatch('setTab', 'group-pois');
				this.$store.dispatch('setGroup', group);
			} else {
				this.showNearestPOI(group);
			}
			//this.parentName = this.currentGroup.names.translations.en;

		},
		onShortcutsButtonClick() {
			this.shortcutsHidden = !this.shortcutsHidden;
		},
		handleChangeValue() {
			this.shortcutsHidden = false;
		},
		onMapPOIClick (poi) {
			this.$store.dispatch('setPOI', poi);
			this.$wayfinder.clearHighlights();
			this.$wayfinder.clearDisplaying();
			this.$wayfinder.setHighlights([poi]);
			this.$wayfinder.setDisplaying([poi]);
			this.$store.dispatch('setTab', 'poi-info');
		},
		activateMenu (active) {
			this.menuActive = active;
			//this.searchVisible = false;
			this.$store.dispatch('showSearch', false);
		},
		onPOIClick (poi) {
			this.$store.dispatch('setPOI', poi);
			this.activateMenu(false);
			this.$wayfinder.clearHighlights();
			this.$wayfinder.clearDisplaying();
			this.$wayfinder.setHighlights([poi]);
			this.$wayfinder.setDisplaying([poi]);
			this.$wayfinder.showPath(poi.getNode(), poi);
			this.$store.dispatch('setTab', 'poi-info');

			if (this.template.poiinfoShowFloor && poi.getNode()) {
				this.$wayfinder.showFloor(poi.getNode().getFloor());
			}
			if (this.template.poiinfoShowPath && poi.getNode()) {
				this.$wayfinder.showPath(poi.getNode(), poi);
			}

			this.$wayfinder.statistics.onClick(poi.id, "menu");
		},
		onSearchPOIClick (poi) {
			if (poi) {
				this.onPOIClick(poi);
				this.$wayfinder.showPath(poi.getNode(), poi)
				this.$wayfinder.clearHighlights();
				this.$wayfinder.setHighlights([poi]);
			}
		},
		onSearchClose () {
			//this.searchVisible = false;
			this.$store.dispatch('showSearch', false);
		},
		reset () {
			this.$store.dispatch('setTab', 'groups');
			//this.searchVisible = false;
			this.$store.dispatch('showSearch', false);
			this.$store.dispatch('setGroup', null);
			this.$store.dispatch('wf/SET_RESET');
			this.screensaver = this.hasScreensaver;
			this.overlayOpen = false;
			//this.browserOpen = false;
			if(this.$refs['map']) {
				this.$refs['map'].pause();
			}

			if(this.$refs['search']) {
				this.$refs['search'].resetValues();
			}
			
			if (typeof fully !== "undefined") {
				fully.hideKeyboard();
				//alert("hideKeyboard")
			}
		},
		doSomething () {},
		switchMainTab (tab) {
			if (tab !== 'search') {
				if (!(tab === 'poi-info' && !this.landsape)) {
					this.$store.dispatch('setTab', tab);
				}

				this.activateMenu(true);
			}
			else {
				//this.searchVisible = !this.searchVisible;
				this.$store.dispatch('showSearch', !this.searchVisible);
				//console.log("State Change")
			}
		},
		onBannerClick (/*frame, container*/) {
			console.log('onBannerClick')
			this.screensaver = false;
			this.$refs['map'].run();
		},
		hideBanner () {
			this.screensaver = false;
		},
		mapLoaded () {
			this.$refs['map'].run();
			this.$store.dispatch('setGroup', null);
			this.qrURL = this.qrURL.replace("{kiosk}", this.$wayfinder.getKiosk());
			this.qrURL = this.qrURL.replace("{rot}", 0);
			this.loading = false;
		},
		hasBanners (has) {
			this.hasScreensaver = has;
		},
		openOverlay (id) {
			this.overlayOpen = true;
			this.overlayImage = id;
		},
		closeOverlay () {
			this.overlayOpen = false;
		},
		openBrowser () {
			this.browserOpen = true;
		},
		closeBrowser () {
			this.browserOpen = false;
		},
		showShortcut (shortcut) {
			var nearest = this.$wayfinder.getNearestPOI(this.$wayfinder.getKiosk(), shortcut.pois);
			if (typeof nearest === 'object') {
				this.menuActive = false;
				this.$wayfinder.showPath(nearest.node, nearest);
				
			}
			this.shortcutsHidden = false;
		}
	}
};
</script>

<style lang="less">
	@import 'theme/styles';
	@import 'theme/responsive';
	@font-face {
		font-family: "PF Square Sans Pro Medium";
		src: local("PF Square Sans Pro"),
		url(./fonts/PFSquareSansProMedium_35487.ttf) format("truetype");
	}

	@font-face {
		font-family: "PF Centro Sans Pro Bold";
		src: local("PF Centro Sans Pro"),
		url(./fonts/PFCentroSansPro-Bold-subset.otf) format("opentype");
	}
	@font-face {
		font-family: "PF Centro Sans Pro Regular";
		src: local("PF Centro Sans Pro"),
		url(./fonts/PFCentroSansPro-Reg-subset.otf) format("opentype");
	}
	@font-face {
		font-family: "Gotham Thin";
		src: local("Gotham Thin"),
		url(./fonts/Gotham-Book.otf) format("opentype");
	};
	@font-face {
		font-family: "Gotham Regular";
		src: local("Gotham Thin"),
		url(./fonts/Gotham-Medium.otf) format("opentype");
	};
	@font-face {
		font-family: "Gotham Bold";
		src: local("Gotham Bold"),
		url(./fonts/Gotham-Bold.otf) format("opentype");
	};
</style>
